import makeStyles from '@mui/styles/makeStyles';
import { styled } from "@mui/material/styles";

const textDefaultColor = "#465869";
const textBlueColor = "#308CDB";
const textLightGrayColor = "#9CA6AF";
const textLightBlueColor = "#EDF5FB";

export const ContainerDetailsWrapper = styled("div")(() => ({
  display: "grid",
  gridTemplateColumns: ".5fr .75fr .75fr 1fr 1fr .5fr",
  gridTemplateAreas: "'order firstName lastName email phone contactVia'",
  gap: 5,
  padding: "0 10px",
  marginBottom: "1rem",
  "@media screen and (max-width: 1024px)": {
    display: "flex",
    flexWrap: "wrap",
    gap: 10,
  },
}));

export const ContainerDetailsArea = styled("div")(() => ({
  display: "flex",
  alignItems: "flex-start",
  flexDirection: "column",
}));

export const ContainerDetailsLabel = styled("label")(() => ({
  color: textBlueColor,
  font: getTextStyle("14px", 600),
}));

interface CustomerDetailsValueProps {
  isEmpty?: boolean;
}
export const CustomerDetailsValue = styled("span")(({ isEmpty }: CustomerDetailsValueProps) => ({
  color: isEmpty ? textLightGrayColor : textDefaultColor,
  font: getTextStyle("14px", 500),
}));

const getTextStyle = (fontSize: string, weight: number) => {
  return `${weight} ${fontSize}/24px Manrope`;
};

const styles = makeStyles(() => ({
  titleSubContainer: {
    color: textDefaultColor,
    font: getTextStyle("16px", 700),
  },
  labelContainer: {
    display: "flex",
    flexDirection: "column",
    alignItems: "flex-start",
    justifyContent: "flex-start",
  },
  mt20: {
    marginTop: 20,
  },
  label: {
    color: textBlueColor,
    font: getTextStyle("14px", 600),
  },
  span: {
    color: textDefaultColor,
    font: getTextStyle("14px", 500),
  },
  phoneInput: {
    marginTop: 10,
    "& > input": {
      border: "none !important",
      boxShadow: "none !important",
      background: "transparent !important",
      "&:hover": {
        border: "none !important",
      },
    },
    "& .flag-dropdown": {
      "& .flag": {
        "& .arrow": {
          display: "none !important",
        },
      },
    },
  },
  emptySpan: {
    font: getTextStyle("14px", 500),
    color: textLightGrayColor,
  },
  tags: {
    backgroundColor: textLightBlueColor,
    color: textBlueColor,
    padding: "4px 8px",
    borderRadius: 4,
  },
  tagWrapper: {
    display: "flex",
    flexDirection: "row",
    gap: 5,
  },
  grindPartner: {
    margin: 0,
    padding: 0,
    width: "max-content",
  },
  checkboxPartner: {
    marginTop: "10.5px",
    marginBottom: "18.5px",
  },
}));

export default styles;
